import { useEffect, useState } from "react";
import { subscribe } from "../lib/uploadManager";

/**
 * Wave 26.8 — `useUploads()` subscribes to the global upload manager.
 *
 * Without args → returns ALL items (used by the global UploadDock).
 *
 * With (target_kind, target_id) → returns only items for that target.
 * This is what JC tasks / ticket detail / customer gallery use to
 * show their own per-row "Uploading 1/3 · 47%" pill.
 *
 * Re-renders happen on every manager state change.  The manager keeps
 * its own immutable snapshot and emits new arrays each time so React
 * never sees mutated data.
 */
export default function useUploads(target_kind, target_id) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const unsub = subscribe((snap) => {
      if (target_kind && target_id) {
        setItems(snap.filter((s) => s.target_kind === target_kind && s.target_id === target_id));
      } else {
        setItems(snap);
      }
    });
    return unsub;
  }, [target_kind, target_id]);
  return items;
}
